import React from 'react';
import { Paper, Typography, TextField, Button, Stack, Alert } from '@mui/material';
import { importExcelRows } from './bie.apis';
import FEditableGrid, { FEditableGridColumn, FEditableGridPayload } from '../../../components/egrid';

type Props = {
  scenario: string;
  onImported: () => void;
};

type State = {
  text: string;
  loading: boolean;
  message?: string;
  error?: string;
};

class ImportWizard extends React.PureComponent<Props, State> {
  state: State = {
    text: '[{"etc":"SALE","enc":"SUPER","lcc":"BINGO","pdc":"2026M01","qty":1000000,"upr":735,"amt":735000000}]',
    loading: false,
  };

  gform: FEditableGridColumn[] = [
    { id: 'eti', label: 'Type', type: 'fa', req: 1, width: 120, cp: {t:'bcs',s:'bieentrytype'} },
    { id: 'pdi', label: 'Period', type: 'fa', req: 1, width: 120, cp: {t:'bcs',s:'bieperiod'} },
    { id: 'eni', label: 'Entity', type: 'fa', req: 1, width: 150, cp: {t:'bcs',s:'bieentity'}},
    { id: 'lci', label: 'Location', type: 'fa', req: 1, width: 150, cp: {t:'bcs',s:'bielocation'} },
    { id: 'aci', label: 'Account', type: 'fa', req: 0, width: 130, cp: {t:'bcs',s:'chartofaccounts'}, }, //ops: {slotProps:{paper:{sx:{width:'fit-content'}}}}
    { id: 'dri', label: 'Driver', type: 'fa', req: 0, width: 150,  cp: {t:'bcs',s:'biedriver'} },
    { id: 'ref', label: 'Reference', type: 'tf', req: 1, width: 220 },
    { id: 'qty', label: 'Quantity', type: 'nf', req: 0, width: 120, defaultValue: 0 },
    { id: 'upr', label: 'Unit Price', type: 'nf', req: 0, width: 120, defaultValue: 0 },
    { id: 'amt', label: 'Amount', type: 'nf', req: 0, width: 140, defaultValue: 0 },
    { id: 'dsc', label: 'Description', type: 'tf', req: 0, width: 240 },
  ];
  
    postBiz = async (payload: any) => {
      const res = await fetch('/biz', { method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'include', body: JSON.stringify(payload) });
      const json = await res.json();
      if (!res.ok || json.failure) throw new Error(json.em || 'Request failed');
      return json;
    };
  
    onSubmit = async (payload: FEditableGridPayload) => {
      const {scenario} = this.props;
      const record = payload.rcd.map((row:any) => ({ scc: scenario, ...row }))
      await this.postBiz({
        s: 'bieimport', 
        a: 'console', 
        trk: null, 
        soc: 'MANUAL', 
        scc: scenario,
        rcd: record,
        fnm: 'manual_edit_grid.json', 
        fdt: {}, 
        att: {}, 
        exi: { origin: 'FEditableGrid' }, 
        rmk: 'Manual editable grid',
      });
    };

  handleImport = async () => {
    try {
      this.setState({ loading: true, error: undefined, message: undefined });
      const records = JSON.parse(this.state.text);
      const res: any = await importExcelRows(this.props.scenario, records);
      this.setState({ message: `Imported ${res.rc || res.sd?.rc || 0} record(s)` });
      this.props.onImported();
    } catch (e: any) {
      this.setState({ error: e.message || String(e) });
    } finally {
      this.setState({ loading: false });
    }
  };

  render() {
    return (
      <Paper elevation={1} sx={{ p: 2 }}>
        <Typography variant="h6" gutterBottom>Quick Import</Typography>
        <Stack spacing={2}>
          {this.state.error && <Alert severity="error">{this.state.error}</Alert>}
          {this.state.message && <Alert severity="success">{this.state.message}</Alert>}
          <TextField
            label="Import records JSON"
            value={this.state.text}
            onChange={(e) => this.setState({ text: e.target.value })}
            multiline
            minRows={5}
            fullWidth
          />
          <FEditableGrid title="Import Rows" gform={this.gform} height={520} onSubmit={this.onSubmit} />
          <Button variant="contained" disabled={this.state.loading || !this.props.scenario} onClick={this.handleImport}>
            Import Records
          </Button>
        </Stack>
      </Paper>
    );
  }
}

export default ImportWizard;
